import dayjs from 'utils/dayjsConfig';
import { fileDownload } from 'utils/fileDownload';
import { logError } from 'utils/sentryUtils';

import { mmFetch } from './mmFetch';
import { mmFetchWithResponse } from './mmFetchWithResponse';

const specialOrdersApi = {
    cancelSpecialOrder: async (id) => {
        const url = `api/order/v1/special/${id}/cancel`;
        try {
            const response = await mmFetch(url, { method: 'PUT' });
            if (response.ok === true) {
                return true;
            }
            return false;
        } catch (e) {
            logError(e);
            return false;
        }
    },
    createSpecialOrder: async (sendParams) => {
        const url = `api/order/v1/special`;
        try {
            return mmFetchWithResponse(url, {
                method: 'POST',
                body: JSON.stringify(sendParams),
            });
        } catch (e) {
            logError(e);
            return false;
        }
    },
    downloadPDF: async (id) => {
        const url = `api/order/v1/special/${id}/pdf`;
        try {
            const res = await mmFetch(url);
            if (res.ok === true) {
                await fileDownload(res, `special-order-${id}.pdf`);
            }
        } catch (e) {
            logError(e);
        }
    },
    getSpecialOrders: async (status) => {
        const url = `api/order/v1/special?status=${status}`;
        try {
            let response = await mmFetch(url);
            if (response.ok === true) {
                response = await response.json();
                return response.data.orders.map((item) => {
                    const newItem = { ...item };
                    newItem.createdAt = dayjs(newItem.createdAt.date).format('MM/DD/YYYY');
                    newItem.shipDate = dayjs(newItem.shipDate.date).format('MM/DD/YYYY');
                    return newItem;
                });
            }
            return [];
        } catch (e) {
            logError(e);
            return [];
        }
    },
    markShipped: async (id) => {
        const url = `api/order/v1/special/${id}/ship`;
        try {
            const response = await mmFetch(url, { method: 'PUT' });
            if (response.ok === true) {
                return true;
            }
            return false;
        } catch (e) {
            return false;
        }
    },
    purchaseLabel: async (id) => {
        const url = `api/order/v1/special/${id}/purchase`;
        try {
            const response = await mmFetch(url, { method: 'POST' });
            if (response.ok === true) {
                return true;
            }
            return false;
        } catch (e) {
            logError(e);
            return false;
        }
    },
    updateSpecialOrder: async ({ field, id, value }) => {
        const sendParams = field === 'address' ? value : { [field]: value };
        const url = `api/order/v1/special/${id}/update`;
        try {
            await mmFetch(url, {
                method: 'PUT',
                body: JSON.stringify(sendParams),
                headers: {
                    'Content-Type': 'application/json',
                },
            });
            return true;
        } catch (e) {
            logError(e);
            return false;
        }
    },
};

export { specialOrdersApi };
